import { render, staticRenderFns } from "./ComunicationManagement.vue?vue&type=template&id=22cef103"
import script from "./ComunicationManagement.vue?vue&type=script&lang=js"
export * from "./ComunicationManagement.vue?vue&type=script&lang=js"
import style0 from "./ComunicationManagement.vue?vue&type=style&index=0&id=22cef103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports